require('./bootstrap');

import Vue from 'vue';

import EmblaCarousel from 'embla-carousel';
let Flickity = require('flickity');
require('flickity-fullscreen');

import { collapseSection, expandSection } from './src/Helpers';

import MainMenu from './enso/MainMenu.js';
import SvgSprite from './vendor/enso/components/SvgSprite.vue';
import CountriesList from './components/CountriesList.vue';
import TabContainer from './components/TabContainer.js';
import AdventureTabContainer from './components/AdventureTabContainer.js';
import SubNav from './components/SubNav.js';
import AdventurePreview from './components/AdventurePreview.vue';
import CountryPreview from './components/CountryPreview.vue';
import PostsIndex from './components/PostsIndex.vue';
import PostPreview from './components/PostPreview.vue';
import PrintButton from './components/PrintButton.vue';
import VueSharelinks from 'vue-sharelinks';
import AdventuresIndex from './components/AdventuresIndex.vue';
import BookingModal from './components/BookingModal.vue';
import GradingBadge from './components/GradingBadge.vue';
import GradingModal from './components/GradingModal.vue';
import GradingModalButton from './components/GradingModalButton.js';
import CurrencySelect from './components/CurrencySelect.vue';
import DisplayPrice from './components/DisplayPrice.vue';
import EnquiryBooking from './components/EnquiryBooking.vue';
import EnquiryModal from './components/EnquiryModal.vue';
import EnquiryModalButton from './components/EnquiryModalButton';
import AdventureSidebar from './components/AdventureSidebar.vue';
import CharitiesList from './components/CharitiesList.vue';
import ShareThisButton from './components/ShareThisButton.vue';
import ShareThisLinks from './components/ShareThisLinks.vue';
import TeamMemberList from './components/TeamMemberList.vue';
import AccountBookings from './components/AccountBookings.vue';
import AccountInvoices from './components/AccountInvoices.vue';
import AccountSettings from './components/AccountSettings.vue';
import AccountBookingDetails from './components/AccountBookingDetails.vue';
import NewsletterForm from './components/NewsletterForm.vue';
import FormSubmission from './components/FormSubmission.vue';
import NewsletterFormPopup from './components/NewsletterFormPopup.vue';
import BookingSidebarPaymentButton from './components/BookingSidebarPaymentButton.vue';

Vue.component('adventure-preview', AdventurePreview);
Vue.component('adventures-index', AdventuresIndex);
Vue.component('adventure-sidebar', AdventureSidebar);
Vue.component('adventure-tab-container', AdventureTabContainer);
Vue.component('booking-modal', BookingModal);
Vue.component('charities-list', CharitiesList);
Vue.component('countries-list', CountriesList);
Vue.component('country-preview', CountryPreview);
Vue.component('currency-select', CurrencySelect);
Vue.component('display-price', DisplayPrice);
Vue.component('enquiry-booking', EnquiryBooking);
Vue.component('enquiry-modal', EnquiryModal);
Vue.component('enquiry-modal-button', EnquiryModalButton);
Vue.component('grading-badge', GradingBadge);
Vue.component('grading-modal', GradingModal);
Vue.component('grading-modal-button', GradingModalButton);
Vue.component('main-menu', MainMenu);
Vue.component('posts-index', PostsIndex);
Vue.component('post-preview', PostPreview);
Vue.component('print-button', PrintButton);
Vue.component('share-this-button', ShareThisButton);
Vue.component('share-this-links', ShareThisLinks);
Vue.component('sub-nav', SubNav);
Vue.component('svg-sprite', SvgSprite);
Vue.component('tab-container', TabContainer);
Vue.component('team-member-list', TeamMemberList);
Vue.component('vue-sharelinks', VueSharelinks);
Vue.component('account-bookings', AccountBookings);
Vue.component('account-invoices', AccountInvoices);
Vue.component('account-settings', AccountSettings);
Vue.component('account-booking-details', AccountBookingDetails);
Vue.component('newsletter-form', NewsletterForm);
Vue.component('form-submission', FormSubmission);
Vue.component('newsletter-form-popup', NewsletterFormPopup);
Vue.component('booking-sidebar-payment-button', BookingSidebarPaymentButton);

import store from './store';
import VueRouter from 'vue-router';
import PortalVue from 'portal-vue';
Vue.use(VueRouter);
Vue.use(PortalVue);

new Vue({
  el: '#app',
  store: store,
});

// Carousels
const emblaCarousels = document.getElementsByClassName('embla');

function setupPrevNextBtns(prevBtn, nextBtn, embla) {
  prevBtn.addEventListener('click', embla.scrollPrev, false);
  nextBtn.addEventListener('click', embla.scrollNext, false);
}

function disablePrevNextBtns(prevBtn, nextBtn, embla) {
  return () => {
    if (embla.canScrollPrev()) prevBtn.removeAttribute('disabled');
    else prevBtn.setAttribute('disabled', 'disabled');

    if (embla.canScrollNext()) nextBtn.removeAttribute('disabled');
    else nextBtn.setAttribute('disabled', 'disabled');
  };
}

function setupDotBtns(dotsArray, embla) {
  dotsArray.forEach((dotNode, i) => {
    dotNode.addEventListener('click', () => embla.scrollTo(i), false);
  });
}

function selectDotBtn(dotsArray, embla) {
  const previous = embla.previousScrollSnap();
  const selected = embla.selectedScrollSnap();
  if(dotsArray[previous]) dotsArray[previous].classList.remove('is-selected');
  if(dotsArray[selected]) dotsArray[selected].classList.add('is-selected');
}

function initiateEmblaCarousel(el) {
  const viewPort = el.querySelector('.embla__viewport');
  const prevBtn = el.querySelector('.embla__button--prev');
  const nextBtn = el.querySelector('.embla__button--next');
  const dots = el.querySelector('.embla__dots');
  const dotsArray = dots ? dots.querySelectorAll('.embla__dot') : null;
  // Read the data-slides-to-scroll attribute
  const slidesToScroll = el.getAttribute('data-slides-to-scroll') || 1;
  const embla = EmblaCarousel(viewPort, { loop: false, slidesToScroll: parseInt(slidesToScroll, 10) });

  if (prevBtn && nextBtn) {
    setupPrevNextBtns(prevBtn, nextBtn, embla);
  }

  if (dotsArray) {
    setupDotBtns(dotsArray, embla);
  }

  if (dotsArray) {
    embla.on('select', () => {
      selectDotBtn(dotsArray, embla);
    });
    embla.on('init', () => {
      selectDotBtn(dotsArray, embla);
    });
  }

  if (prevBtn && nextBtn) {
    embla.on('select', () => {
      disablePrevNextBtns(prevBtn, nextBtn, embla);
    });
    embla.on('init', () => {
      disablePrevNextBtns(prevBtn, nextBtn, embla);
    });
  }
}

if (emblaCarousels.length > 0) {
  for (let i = 0; i < emblaCarousels.length; i++) {
    const element = emblaCarousels[i];
    initiateEmblaCarousel(element);
  }
}

// Flickity carousels
const adventure_carousel_elem = document.getElementById('adventureCarousel');
const adventure_carousel_elem_mobile = document.getElementById('adventureCarouselMobile');
const preview_carousels = document.querySelectorAll('.preview-carousel');

function initiateAdventureCarousel(el) {
  let cells = el.getElementsByClassName('carousel__cell');
  let carousel_cell_count = cells.length;

  const carousel = new Flickity(el, {
    wrapAround: carousel_cell_count > 1,
    pageDots: false,
    setGallerySize: false,
    prevNextButtons: true,
    cellAlign: 'left',
    fullscreen: true,
    lazyLoad: 2,
  });

  window.addEventListener('load', () => {
    // Add a "loaded" class to carousels so that we can show slides 2+
    // using CSS. This prevents a flash over misaligned, overlapping images.
    adventure_carousel_elem.classList.add('loaded');

    carousel.resize();
    window.setTimeout(() => carousel.resize, 1000);
  });

  carousel.on('staticClick', (event, pointer, cellElement, cellIndex) => {
    if (!cellElement) {
      return;
    }

    carousel.selectCell(cellIndex, false, true);
    carousel.toggleFullscreen();
  });
}

function initiatePreviewCarousel(el) {
  let cells = el.getElementsByClassName('carousel__cell');
  let carousel_cell_count = cells.length;

  const carousel = new Flickity(el, {
    wrapAround: carousel_cell_count > 1,
    pageDots: true,
    setGallerySize: true,
    prevNextButtons: false,
  });

  window.addEventListener('load', () => {
    // Add a "loaded" class to carousels so that we can show slides 2+
    // using CSS. This prevents a flash over misaligned, overlapping images.
    el.classList.add('loaded');

    carousel.resize();
    window.setTimeout(() => carousel.resize, 1000);
  });
}

if (adventure_carousel_elem) {
  initiateAdventureCarousel(adventure_carousel_elem);
}

if (adventure_carousel_elem_mobile) {
  initiateAdventureCarousel(adventure_carousel_elem_mobile);
}

if (preview_carousels.length > 0) {
  for (let i = 0; i < preview_carousels.length; i++) {
    const element = preview_carousels[i];
    initiatePreviewCarousel(element);
  }
}

// Account nav
const accountNavMobileButton = document.getElementById('accountMenuBtn');
const accountNavMobileMenu = document.getElementById('accountMenu');

function toggleAccountNavMobileMenu() {
  if (!accountNavMobileButton.classList.contains('is-active')) {
    expandSection(accountNavMobileMenu);
    accountNavMobileButton.classList.add('is-active');
  } else if (accountNavMobileButton.classList.contains('is-active')) {
    collapseSection(accountNavMobileMenu);
    accountNavMobileButton.classList.remove('is-active');
  }
}

if (accountNavMobileButton) {
  accountNavMobileButton.addEventListener('click', (e) => {
    e.preventDefault();
    toggleAccountNavMobileMenu();
  });
}

// Footer menus
const footer_menu = document.getElementById('footerMenu');
const footer_menu_toggler = document.getElementById('footerMenuToggler');

if (footer_menu_toggler) {
  footer_menu_toggler.addEventListener('click', (e) => {
    e.preventDefault();

    footer_menu_toggler.classList.toggle('is-active');

    footer_menu.classList.toggle('is-active');
  });
}

const countries_menu = document.getElementById('countriesMenu');
const footer_contries_toggler = document.getElementById('footerCountriesToggler');

if (footer_contries_toggler) {
  footer_contries_toggler.addEventListener('click', (e) => {
    e.preventDefault();

    footer_contries_toggler.classList.toggle('is-active');

    countries_menu.classList.toggle('is-active');
  });
}